import React, {useEffect, useState} from "react"; // <--- 1. Імпортуємо useState
import {BtnBar, DropdownButton} from "./buttons/button";
import ICON from "./const/icon";
import {childrenWithProps, classNames} from "../tools/react.dom.helpers";
import {useResizeDetector} from "react-resize-detector";
import {Icon} from "./index";

/**
 * @see htdocs/v2/js/management/app/view/controller/plugins/PluginsFormView.js
 */
const CollapsibleMenu = ({className, children, caption = 'More', header, type = CollapsibleMenu.TYPE.DOTS, priority = CollapsibleMenu.PRIORITY.HIDE_LAST, position = DropdownButton.POSITION.RIGHT, btnTemplate, dropdownType}) => {

	// 2. Створюємо стан для відстеження ініціалізації
	const [isInitialized, setIsInitialized] = useState(false);

	const {width, ref} = useResizeDetector({
		handleHeight: false,
		refreshMode: 'throttle',
		refreshRate: 500,
	});

	const hide = (elements, isDropdown) => {
		if (!elements?.length) return;
		for (var element of elements) {
			isDropdown ? element.style.display = 'none' : element.hidden = true;
		}
	}

	const show = (elements, isDropdown) => {
		if (!elements?.length) return;
		for (var element of elements) {
			isDropdown ? element.style.display = 'block' : element.hidden = false;
		}
	}

	const visible = elements => [...elements].filter(element => !element.hidden);
	const totalWidth = elements => [...elements].map(element => element.offsetWidth + 8).reduce((a, b) => a + b, 0);
	const last = elements => elements[elements.length - 1];
	const first = elements => elements[0];

	useEffect(() => {
		const buttonContainer = ref.current;

		// Додаємо перевірку на width, щоб не виконувати логіку, поки розмір не визначено
		if (buttonContainer === null || !width) return;

		const buttonSubmenu = buttonContainer.getElementsByClassName('button-submenu');
		const buttonInSubmenu = buttonContainer.getElementsByClassName('button-in-submenu');
		const buttonOutsideSubmenu = buttonContainer.getElementsByClassName('button-outside-submenu');

		hide(buttonSubmenu, true);
		hide(buttonInSubmenu, false);
		show(buttonOutsideSubmenu, false);

		if (!buttonOutsideSubmenu?.length && !buttonInSubmenu?.length) {
			// Навіть якщо кнопок немає, нам все одно потрібно ініціалізувати компонент, щоб він став видимим
			if (!isInitialized) {
				setIsInitialized(true);
			}
			return;
		}

		do {
			let childrenWidth = totalWidth(visible(buttonSubmenu)) + totalWidth(visible(buttonOutsideSubmenu));
			if (width > childrenWidth + 10) break;

			let lastVisibleButton = priority === CollapsibleMenu.PRIORITY.HIDE_LAST ?
				last(visible(buttonOutsideSubmenu)) :
				first(visible(buttonOutsideSubmenu));

			// Запобігаємо нескінченному циклу, якщо видимих кнопок не залишилось
			if (!lastVisibleButton) break;

			show(buttonSubmenu, true);
			show([...buttonInSubmenu].filter(element => element.id === lastVisibleButton.id), false);
			hide([lastVisibleButton], false);
		} while (visible(buttonOutsideSubmenu).length);

		// 3. Після виконання першого розрахунку, встановлюємо стан в true
		// Це спрацює лише один раз і більше не буде викликати re-render через цю умову
		if (!isInitialized) {
			setIsInitialized(true);
		}
		// Додаємо залежності, щоб useEffect працював коректно
	}, [width, children, priority, ref, isInitialized]);

	const innerButtons = (childrenWithProps(children, (child, id) => ({
		className: classNames('button-in-submenu'),
		id: child.props.id || `button_${id}`
	})))

	const dropdown = (
		type === CollapsibleMenu.TYPE.BARS ?
			<DropdownButton containerClass="button-submenu" template={DropdownButton.TEMPLATE.SECONDARY}
							dropdownType={dropdownType} icon={Icon.ICON.MENU_BARS} header={header} position={position}
							mobBar>
				{innerButtons}
			</DropdownButton> :
			type === CollapsibleMenu.TYPE.DOTS ?  //TODO "ellipsis-vertical" icon!
				<DropdownButton containerClass="button-submenu" template={DropdownButton.TEMPLATE.SECONDARY}
								dropdownType={dropdownType} icon={Icon.ICON.MENU_DOTS} header={header} position={position}
								mobBar>
					{innerButtons}
				</DropdownButton> :
				type === CollapsibleMenu.TYPE.MORE_ACTIONS ?
					<DropdownButton containerClass="button-submenu" template={btnTemplate} caption={caption}
									dropdownType={dropdownType} caret header={header} position={position} mobBar>
						{innerButtons}
					</DropdownButton> :
					null
	);

	return (
		// 4. Динамічно додаємо клас 'is-initialized' на основі стану
		<div className={classNames(
			'btn-bar__adaptive-wrapper',
			className,
			{'is-initialized': isInitialized}
		)} ref={ref}>
			<BtnBar className={'btn-bar__adaptive'}>
				{priority === CollapsibleMenu.PRIORITY.HIDE_FIRST ? dropdown : null}
				{childrenWithProps(children, (child, id) => ({
					className: classNames('button-outside-submenu'),
					id: child.props.id || `button_${id}`
				}))}
				{priority === CollapsibleMenu.PRIORITY.HIDE_LAST ? dropdown : null}
			</BtnBar>
		</div>
	);
}

CollapsibleMenu.PRIORITY = {
    HIDE_FIRST: 'hide-first',
    HIDE_LAST: 'hide-last'
};

CollapsibleMenu.TYPE = {
    BARS: 'bars',
    DOTS: 'dots',
    MORE_ACTIONS: 'more-actions'
};

CollapsibleMenu.JUSTIFY = BtnBar.JUSTIFY;

export default CollapsibleMenu;